import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { SingleTradeOrder } from '../../Pages/CreateHPool/CreateHPoolSignTransaction/SignTradeOrders/SingleTradeOrder/SingleTradeOrder';
import { getValueByMultiProps } from '../../../utils/mapper';

const getTokenBySymbol = (assets = [], symbol) => {
  const foundInAssets = assets.find((asset) => asset.token_symbol === symbol);
  return foundInAssets;
};
const getBaseTokenImage = (token) => {
  const img = getValueByMultiProps(token, [
    'base_token_image_large',
    'base_token_image_small',
    'base_token_image_thumb',
  ]);
  return img;
};
const getDstTokenImage = (token) => {
  const img = getValueByMultiProps(token, ['token_image_large', 'token_image_small', 'token_image_thumb']);
  return img;
};

const getTokenImage = (token, isSell) => {
  if (isSell) return [getDstTokenImage(token), getBaseTokenImage(token)];
  return [getBaseTokenImage(token), getDstTokenImage(token)];
};

const swap = (base, dst, isSell) => {
  if (!isSell) return [dst, base];
  return [base, dst];
};

function TradeOrdersConfirm({ tradeOrders = [], getTokenChanges, assets }) {
  const tradeOrdersMapper = (tradeOrder) => {
    const [baseTokenInfo, forTokenInfo] = tradeOrder.token_pair
      .split('/')
      .map((symbol) => getTokenBySymbol(assets, symbol));
    const { order_type: orderType } = tradeOrder || {};
    const isSell = orderType?.toLowerCase?.().includes('sell');
    const [_base, _for] = swap(baseTokenInfo, forTokenInfo, isSell);
    const [baseSymbol, dstSymbol] = swap(...tradeOrder.token_pair.split('/'), isSell);

    return {
      ...tradeOrder,
      baseTokenInfo: { ..._base, img: getDstTokenImage(tradeOrder), name: baseSymbol },
      forTokenInfo: { ..._for, img: getBaseTokenImage(tradeOrder), name: dstSymbol },
    };
  };

  const mappedTradeOrders = useMemo(() => tradeOrders.map(tradeOrdersMapper), [tradeOrders.length]);
  return (
    <>
      {mappedTradeOrders.map((order) => (
        <SingleTradeOrder key={order.id} tradeOrder={order} />
      ))}
    </>
  );
}

const mapStateToProps = ({ createHPool }) => ({
  assets: createHPool.hpool.assets,
  tradeOrders: createHPool.tradeOrders,
});

TradeOrdersConfirm.defaultProps = {
  assets: [],
  tradeOrders: [],
};
TradeOrdersConfirm.propTypes = {
  getTokenChanges: PropTypes.func.isRequired,
  assets: PropTypes.array,
  tradeOrders: PropTypes.array,
};

export default connect(mapStateToProps)(TradeOrdersConfirm);
